import React, { useEffect, useState } from "react";
import { Loader2, Send, HardHat, Building2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import SendForm from "./SendForm";
import { Modal } from "./SendDocModal";
import { formReady, loadDraft, sendForm } from "../lib/docSend";

const TARGETS = [["sous_traitant", "Sous-traitant poseur", HardHat], ["regie", "Régie", Building2]];

export default function EnvoiPoseFlowModal({ dossier, onClose, onSent }) {
  const [forms, setForms] = useState({});
  const [on, setOn] = useState({ sous_traitant: true, regie: true });
  const [busy, setBusy] = useState(false);
  const [docs, setDocs] = useState([]);
  useEffect(() => {
    api.get(`/dossiers/${dossier.id}/send-catalog`).then((r) => {
      const om = r.data.groups[0].items.find((i) => i.id.startsWith("om_") && i.applicable) || r.data.groups[0].items[0];
      setDocs([om.id, "dossier_pose"]);
      TARGETS.forEach(([role]) => loadDraft(dossier.id, [om.id, "dossier_pose"], role).then((f) => setForms((x) => ({ ...x, [role]: f }))));
    }).catch(() => toast.error("Chargement impossible"));
  }, [dossier.id]);
  const active = TARGETS.filter(([r]) => on[r] && forms[r]);
  const ready = active.length > 0 && active.every(([r]) => formReady(forms[r]));
  const send = async () => {
    const wins = Object.fromEntries(active.map(([r]) => [r, forms[r].channels.whatsapp ? window.open("", "_blank") : null]));
    setBusy(true);
    const done = [];
    for (const [r, label] of active) {
      try { await sendForm(dossier.id, forms[r], wins[r]); done.push(label); setOn((x) => ({ ...x, [r]: false })); }
      catch (e) { wins[r]?.close(); toast.error(`${label} : ${e?.response?.data?.detail || "envoi impossible"}`); }
    }
    setBusy(false);
    if (done.length) { toast.success(`Envoi en pose : ${done.join(" et ")}`); onSent?.(); }
    if (done.length === active.length) onClose();
  };
  return (
    <Modal title="Envoi en pose — OM + dossier de pose" onClose={onClose} testid="envoi-pose-flow-modal" wide
      footer={<>
        <button onClick={onClose} className="btn-secondary text-sm">Annuler</button>
        <button onClick={send} disabled={busy || !ready} className="btn-primary text-sm" data-testid="envoi-pose-flow-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Tout envoyer</button>
      </>}>
      <div className="space-y-6">
        {TARGETS.map(([role, label, Icon]) => (
          <section key={role} className={`transition-opacity ${on[role] ? "" : "opacity-50"}`} data-testid={`envoi-pose-flow-${role}`}>
            <label className="flex items-center gap-2 mb-3 cursor-pointer">
              <input type="checkbox" checked={on[role]} onChange={(e) => setOn({ ...on, [role]: e.target.checked })} data-testid={`envoi-pose-flow-toggle-${role}`} />
              <Icon className="w-4 h-4 text-norea-primary" /><span className="font-heading text-base font-medium">{label}</span>
            </label>
            {!forms[role] ? <Loader2 className="w-4 h-4 animate-spin" /> : on[role] && (
              <SendForm dossierId={dossier.id} form={forms[role]} setForm={(f) => setForms((x) => ({ ...x, [role]: f }))} onRole={() => {}} lockRole prefix={`pose-${role}`}
                onTemplate={(tid) => loadDraft(dossier.id, docs, role, tid).then((f) => setForms((x) => ({ ...x, [role]: f })))} />
            )}
          </section>
        ))}
      </div>
    </Modal>
  );
}
